import { AD_STATUS } from "../utils/enums";
import SortDropdown from "./SortDropdown";

const OPTIONS = [
  { value: AD_STATUS.ALL, label: "All" },
  { value: AD_STATUS.UNDER_REVIEW, label: "Under Review" },
  { value: AD_STATUS.ON_SALE, label: "Open for Bid" },
  { value: AD_STATUS.SOLD, label: "Sold" },
  { value: AD_STATUS.CLOSED, label: "Closed" },
];

const AdStatusDropdown = ({ value, onChange }: any) => (
  <SortDropdown
    label="Status"
    icon="bi-funnel"
    options={OPTIONS}
    value={value || AD_STATUS.ALL}
    onChange={onChange}
  />
);

export default AdStatusDropdown;
